import { render, staticRenderFns } from "./TracebackTable.vue?vue&type=template&id=63f796b8&scoped=true&"
import script from "./TracebackTable.vue?vue&type=script&lang=js&"
export * from "./TracebackTable.vue?vue&type=script&lang=js&"
import style0 from "./TracebackTable.vue?vue&type=style&index=0&id=63f796b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f796b8",
  null
  
)

export default component.exports